import actionCreatorFactory from 'typescript-fsa';

import * as api from '../api';
import * as store from './store';

const actionCreator = actionCreatorFactory();

interface FormStatusAction {
  formSetId: string;
  formId: string;
  status: api.PrevisitForm.Status;
}
export const setFormStatus = actionCreator<FormStatusAction>('SET_FORM_STATUS');
export function setFormStatusHandler(
  state: store.All,
  args: FormStatusAction,
): store.All {
  const { formSetId, formId, status } = args;
  const forms = state.formSets[formSetId].forms;
  const form = forms[formId];
  if (!form) {
    console.warn('form not found');
    return state;
  }
  form.status = status;
  return {
    ...state,
    formSets: {
      ...state.formSets,
      [formSetId]: {
        ...state.formSets[formSetId],
        forms: {
          ...state.formSets[formSetId].forms,
          [formId]: form,
        },
      },
    },
  };
}

export const setSelectedFormId = actionCreator<string | null>(
  'SET_SELECTED_FORM_ID',
);
export function setSelectedFormIdHandler(
  state: store.All,
  selectedFormId: string | null,
): store.All {
  return {
    ...state,
    selectedFormId,
  };
}
